import React from 'react';

const ProductSubBrand = ({ product, className = 'mb-0.5' }) => {
  if (!product?.metafields?.subBrand) return null;

  return (
    <p className={`body-3 flex items-center gap-0.5 [&_img]:size-5 ${className}`}>
      {product?.metafields?.subBrand}
      <domaine-inline-icons data-icon={product?.metafields?.subBrand}></domaine-inline-icons>
    </p>
  );
};

export default ProductSubBrand;
